const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var SelectAll24 = function SelectAll24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 5C2 3.34315 3.34315 2 5 2H15C16.6569 2 18 3.34315 18 5V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V5ZM8.60485 12.9276C8.72621 12.9779 8.85634 13.0037 8.98771 13.0033H9.04371C9.18402 12.9946 9.32094 12.9565 9.44551 12.8914C9.57009 12.8262 9.67954 12.7356 9.76671 12.6253L13.7667 7.6253C13.9325 7.41816 14.0092 7.15366 13.9799 6.88999C13.9506 6.62631 13.8178 6.38506 13.6107 6.2193C13.4036 6.05354 13.1391 5.97685 12.8754 6.0061C12.6117 6.03536 12.3705 6.16816 12.2047 6.3753L8.90471 10.5033L7.69471 9.2963C7.50611 9.11414 7.25351 9.01334 6.99131 9.01562C6.72911 9.0179 6.4783 9.12307 6.29289 9.30848C6.10749 9.49389 6.00232 9.7447 6.00004 10.0069C5.99776 10.2691 6.09855 10.5217 6.28071 10.7103L8.28071 12.7103C8.37332 12.8035 8.48349 12.8773 8.60485 12.9276Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V9C21.9984 8.47005 21.7872 7.96227 21.4125 7.58753C21.0377 7.2128 20.5299 7.00158 20 7V20H6C6.00158 20.5299 6.2128 21.0377 6.58753 21.4125C6.96227 21.7872 7.47005 21.9984 8 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071Z",
      fill: "currentColor",
    })
  );
};
SelectAll24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: SelectAll24,
};
export function SelectAll(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'SelectAll' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
